import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

const base = API_BASE_URL;

const handle = (err, fallback) => {
    if (err.response?.data) throw err.response.data;
    throw err.message || fallback;
};

// GET the client dropdown list — first row is a synthetic "SelectAll" entry with Clientcode='0'
export const getAllTDSClients = async () => {
    try {
        const res = await axios.get(`${base}/Reports/GetAllTDSclients`);
        return res.data;
    } catch (err) { return handle(err, 'Failed to fetch clients'); }
};

// GET sub-clients for a client — the backend special-cases clientcode==='SelectAll' (literal
// string, not the '0' the client list actually uses for its own "select all" row — a
// pre-existing mismatch in legacy/backend, not something to "fix" here) to return every
// sub-client across all clients instead of filtering by one.
export const getSubClientsByClientForTDSReport = async (clientcode) => {
    try {
        const res = await axios.get(`${base}/Reports/GetSubClientsbyClientForTDSReport`, { params: { clientcode } });
        return res.data;
    } catch (err) { return handle(err, 'Failed to fetch sub-clients'); }
};

export const getAllFinancialYears = async () => {
    try {
        const res = await axios.get(`${base}/Accounts/GetAllFinancialYears`);
        return res.data;
    } catch (err) { return handle(err, 'Failed to fetch financial years'); }
};

export const viewClientTDSReportGrid = async ({ Clientcode, SubClientcode, FromDate, ToDate, SearchBy, StartYear, EndYear }) => {
    try {
        const res = await axios.get(`${base}/Reports/ViewClientTDSReportGrid`, {
            params: { Clientcode, SubClientcode, FromDate, ToDate, SearchBy, StartYear, EndYear },
        });
        return res.data;
    } catch (err) { return handle(err, 'Failed to fetch client TDS report'); }
};
